import type { ParamMatcher } from '@sveltejs/kit';
import type { AssetTypeIdentifier } from '$types/assetTypeIdentifier';

const SUPPORTED_TRANSACTION_ASSETS = ['xdai', 'eure', 'gbpe', 'crc', 'usdc', 'usdc-old', 'gno'];

export const match: ParamMatcher = (param): param is AssetTypeIdentifier => {
  return SUPPORTED_TRANSACTION_ASSETS.includes(param);
};
